var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"report","fluid":""}},[_c('timeline-dashboard'),_c('eye-tracking-dashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }